<app-top-header></app-top-header>
@if (isMobile$ | async) {
    <app-navbar-mobile></app-navbar-mobile>
} @else {
    <app-navbar class="navbar"/>
}

<router-outlet />

<app-footer></app-footer>
